import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Badge } from 'components/chroma';
import THEME from 'theme';

const ProgressSection = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  position: relative;
`;

const BadgeWrapper = styled.div`
  .c-badge--primary {
    background-color: ${THEME.BADGE.BACKGROUND.PRIMARY} !important;
    color: ${THEME.BADGE.TEXT.PRIMARY} !important;
  }
  .c-badge--secondary {
    background-color: ${THEME.BADGE.BACKGROUND.SECONDARY} !important;
    color: ${THEME.BADGE.TEXT.SECONDARY} !important;
  }
  .c-badge--tertiary {
    background-color: ${THEME.BADGE.BACKGROUND.TIERTARY} !important;
    color: ${THEME.BADGE.TEXT.TIERTARY} !important;
    border: 2px ${THEME.BADGE.BORDER.TIERTARY} solid;
  }
`;

const ProgressBackground = styled.div<{
  isLastPrequoteStep?: boolean;
  isFirstPostquoteStep?: boolean;
}>`
  height: 2px;
  width: 100%;
  min-width: ${({ isLastPrequoteStep, isFirstPostquoteStep }) =>
    isLastPrequoteStep || isFirstPostquoteStep ? '20px' : '50px'};
  background: ${({ isLastPrequoteStep, isFirstPostquoteStep }) => {
    if (isLastPrequoteStep)
      return 'linear-gradient(90deg, rgba(181, 181, 181, 1) 35%, rgba(255, 255, 255, 0) 100%)';
    if (isFirstPostquoteStep)
      return 'linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(181, 181, 181, 1) 100%)';
    return '#b5b5b5';
  }};
`;

const Progress = styled.div<{
  progress: number;
  isCurrentFlow: boolean;
  isFlowComplete: boolean;
  isFirstPostquoteStep?: boolean;
}>`
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
  background: ${({ isFirstPostquoteStep }) =>
    isFirstPostquoteStep
      ? 'linear-gradient(90deg, rgba(255,255,255,0) 25%, rgba(64,64,64,1) 100%)'
      : '#404040'};
  transition-property: width;
  transition-duration: 0.2s;
  max-width: 100%;

  width: ${({ progress, isCurrentFlow, isFlowComplete }) => {
    if (isCurrentFlow) {
      return `${progress}%`;
    }
    if (isFlowComplete) {
      return `100%`;
    }
    return `0%`;
  }};
`;

const FlowIcon: FunctionComponent<{
  isCurrentFlow: boolean;
  flowName: string;
  isFlowComplete: boolean;
  flowNumber: number;
}> = ({ isCurrentFlow, flowName, isFlowComplete, flowNumber }) => (
  <BadgeWrapper>
    <Badge
      numbered
      tertiary={isCurrentFlow}
      primary={isFlowComplete}
      secondary={!isCurrentFlow && !isFlowComplete}
      ariaLabel={`${flowNumber} ${flowName}`}
    >
      {flowNumber}
    </Badge>
  </BadgeWrapper>
);

const NumberedProgressBarItem: FunctionComponent<{
  flowNumber: number;
  flowName: string;
  isCurrentFlow: boolean;
  isFlowComplete: boolean;
  progress: number;
  isLastPrequoteStep?: boolean;
  isFirstPostquoteStep?: boolean;
  isLastPostQuoteStep?: boolean;
}> = ({
  flowNumber,
  flowName,
  isCurrentFlow,
  isFlowComplete,
  progress,
  isLastPrequoteStep,
  isFirstPostquoteStep,
  isLastPostQuoteStep,
}) => (
  <ProgressSection>
    {isFirstPostquoteStep && (
      <ProgressBackground isFirstPostquoteStep>
        <Progress
          progress={progress}
          isCurrentFlow={false}
          isFirstPostquoteStep
          isFlowComplete
        />
      </ProgressBackground>
    )}
    <FlowIcon
      isCurrentFlow={isCurrentFlow}
      flowName={flowName}
      isFlowComplete={isFlowComplete}
      flowNumber={flowNumber}
    />
    {!isLastPostQuoteStep && (
      <ProgressBackground isLastPrequoteStep={isLastPrequoteStep}>
        <Progress
          progress={progress}
          isCurrentFlow={isCurrentFlow}
          isFlowComplete={isFlowComplete}
        />
      </ProgressBackground>
    )}
  </ProgressSection>
);

export default NumberedProgressBarItem;
